import {Link} from 'react-router-dom'

import styles from './RequestDetails.module.scss'
import {
  Box,
  Button,
  Block,
  UserAvatar,
  Text,
  IconTitle,
  VerticalDivider,
  RequestFifthIcon,
} from 'common/components'
import {formatMoney, formatDate} from 'common/helpers'

interface RequestDetailsProps {
  projectView?: boolean
  project: any
  request?: any
}

interface LoanProps {
  request: any
}

interface BrokerProps {
  broker: any
}

export default function RequestDetails({
  projectView,
  project,
  request,
}: RequestDetailsProps) {
  // console.log(projectView)
  // console.log(project)
  // console.log(request)
  const content = (
    <>
      {projectView ? (
        <Loan request={project.loanRequests[0]} />
      ) : (
        <IconTitle icon={<RequestFifthIcon />} mb={12}>
          Request details
        </IconTitle>
      )}

      <div className={styles.info}>
        <MemberInfo title="Created by" 
          name={[request?.createdBy?.firstName || '', request?.createdBy?.lastName || ''].filter((x:string)=> !!x).join(' ')}
          avatar={request?.createdBy?.photo || ''}
        />
      </div>
      <div className={styles.info}>
        { ( (!!request?.borrowerName) || (!!request?.borrowerEmail) || (!!request?.borrowerPhoneNumber) ) &&
          <MemberInfo title="Borrower info"
            name={request?.borrowerName}
            email={request?.borrowerEmail}
            phoneNumber={request?.borrowerPhoneNumber}
          />
        }
        { ( (!!request?.brokerName) || (!!request?.brokerEmail) || (!!request?.brokerPhoneNumber) ) &&
          <MemberInfo title="Broker info"
            name={request?.brokerName}
            email={request?.brokerEmail}
            phoneNumber={request?.brokerPhoneNumber}
          />
        }
      </div>

      <Text size="2xs" weight="demiBold" mb={4} className={styles.label}>Project Details</Text>
      <Text size="xs" mb={32}>{project?.description || ''}</Text>

      <div className={styles.block}>
        <div style={{flex: 1}}>
          <Text size="2xs" weight="demiBold" mb={4} className={styles.label}>Documents</Text>
          {/* <Text size="xs">
            Resource consent, Engineering plan approval, Building consent,
            Project Feasibility has been uploaded.
          </Text> */}
          <Link tabIndex={-1} to="documents">
            <Button variant="secondary" style={{marginTop: '16px'}}>view documents</Button>
          </Link>
        </div>
        <VerticalDivider />
        <Box align="center">
          <Text size="2xs" weight="demiBold" mb={4} className={styles.label}>Units</Text>
          <Text size="4xl">{project?.units || ''}</Text>
        </Box>
      </div>
      {/* <Link tabIndex={-1} to="documents">
        <Button variant="secondary">view documents</Button>
      </Link> */}
      <Box mt={32}>
        <Text size="2xs" weight="demiBold" mb={4} className={styles.label}>Borrower background</Text>
        <Text size="xs">{request?.borrowerBackground}</Text>
      </Box>
      {!!project?.brokerProfile && <Broker broker={project.brokerProfile} />}
    </>
  )

  if (projectView) return content

  return (
    <Block className={styles.root} type="white">
      {content}
    </Block>
  )
}

const Loan = ({request}: LoanProps) => {
  return (
    <Box mb={24}>
      <Text mb={6}>Requested {formatMoney(request.loanValueRequested)}</Text>
      <Text size="xs" color="grey">
        Est. {formatDate(request.openDate)} ⇢ Est.{' '}
        {formatDate(request.maturityDate)}
      </Text>
    </Box>
  )
}

const MemberInfo = ({ title, name, avatar, email, phoneNumber }: {
  title: string;
  name: string;
  avatar?: string;
  email?: string;
  phoneNumber?: string;
}) => (
  <div className={styles['member-info']}>
    <Text size="2xs" weight="demiBold" mb={6} className={styles.label}>{title}</Text>
    { (undefined === avatar) ?
      <Text size="xs" >{name}</Text>
      :
      <div className={styles['created-by']}>
        <UserAvatar
          size={16}
          alt='created by'
          src={avatar || ''}
        />
        <Text size="xs" mb={32}>
          {name}
        </Text>
      </div>
    }
    { !!email && <Text size="xs" >{email}</Text> }
    { !!phoneNumber && <Text size="xs" mb={32} >{phoneNumber}</Text> }
  </div>
)

const Broker = ({broker}: BrokerProps) => {
  const user = broker.users[0]

  return (
    <Box mt={32}>
      <p className={styles.label}>Broker</p>
      {user && (
        <Text size="xs" weight="medium" mb={2}>
          {user.firstName} {user.lastName}
        </Text>
      )}
      <Text size="xs">
        #{broker.licenceNumber}
        {broker.licenceType !== 'individual' && (
          <>
            <Box as="span" ml={5} mr={5}>
              •
            </Box>
            {broker.title}
          </>
        )}
      </Text>
    </Box>
  )
}
